/**
 * Study Mode Header component
 * Minimal header for Study Mode app
 */

import {Link} from 'react-router-dom';
import {ROUTES} from '../../config/constants';

export function StudyHeader() {
  return (
    <header className="bg-white dark:bg-[#252526] border-b border-gray-200 dark:border-gray-700 h-14 flex items-center px-4">
      <Link to={ROUTES.STUDY_APP} className="flex items-center gap-2">
        <span className="text-lg font-semibold text-textPrimary dark:text-[#CCCCCC]">
          Study Mode
        </span>
      </Link>
    </header>
  );
}

